import '..//..//..//mixins.js'
import Accordion from "../../Accordion.vue"
import Tabs from "../../general/Tabs/Tabs.vue"
import Tab from "../../general/Tab/Tab.vue"
import spinner from "../../LoadingComponent/LoadingComponent.vue"
import { mapGetters } from 'vuex'
import AnimatedNumber from "animated-number-vue"

// npm install --save-dev @fortawesome/fontawesome-free

export default {
  name: 'portfolio',
  components: {
    Accordion,
    Tab,
    Tabs,
    spinner,
    AnimatedNumber

  },
  props: {"tokenValid": Boolean},
  data () {
    return {
      tableDivContent: "",
      id : this.$route.params.id,
      isPortfolioEmpty: false,
      isLoaded: false,
      test: null,
      dateToday: new Date().toISOString().split('T')[0],
      responseDataPortfolio: [],
      totalPortfolio: {
        latest_value: 0,
        total_purchase_value: 0,
        return: 0
      },
      stockRecommendation: {
        name: "",
        isin: "",
        price: "",
        amount: "",
        totalValue: ""
      },
      isAssetModalVisible: false,
      assetModalIndex: 0,
      modalInput: [],
      responsePostData: null,
      securitySearch: null,
      showResultsName: false,
      showResultsIsin: false,
      showSpinner: true,
      showSpinnerModal: false,
      priceSeries: null,
    }
  },
  computed: {
    calcAbsoluteProfitLoss: function(){
      return Math.round((this.totalPortfolio.latest_value - this.totalPortfolio.total_purchase_value)*100)/100;
    },
    calcRelativeProfitLoss: function(){
        if(this.totalPortfolio.total_purchase_value > 0){ return Math.round((this.totalPortfolio.latest_value - this.totalPortfolio.total_purchase_value) / this.totalPortfolio.total_purchase_value * 10000, 2) / 100;}
        else{return 0}
    },
    ...mapGetters(['get_SP_portfolioData'])
  
  },
  async created(){
    this.loadData();
  },
  beforeMount () {
    
  },
  mounted () {
    this.updateHeight();
    window.addEventListener("resize", this.myEventHandler);
    
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    loadData: async function() {
      this.showSpinner = false;
      this.portfolio = this.get_SP_portfolioData['depot']
      if (this.portfolio == null){
        this.isPortfolioEmpty = true;
      }
      this.isLoaded = true;
      this.showSpinner = false;
      
     
    },
    myEventHandler() {
      this.updateHeight();
    },
    checkScrollPosition(){
      if(document.getElementById("grid-table-body").innerHeight == document.getElementById("grid-table-body").scrollTop){
        console.log(true)
      }
      else{
        console.log(document.getElementById("grid-table-body").scrollTop,document.getElementById("grid-table-body").scrollHeight, document.getElementById("grid-table-body").offsetHeight)
      }
    },
    calculateTotalPortfolio: function(){
      var pV= 0;  
      var cV = 0;
      this.portfolio.forEach(position => {
      pV += position.latest_value;
      cV += position.total_purchase_value;
      });
      
      this.totalPortfolio.total_purchase_value = Math.round(cV*100)/100;
      this.totalPortfolio.latest_value = Math.round(pV*100)/100;
      //totalPortfolio.totalReturn = Math.round((cV / pV - 1) * 10000) /100;
    },
    updateHeight: function(){
        var portfolioDivHeight = document.getElementById("portfolio-dashboard-div").offsetHeight;
        console.log(portfolioDivHeight)
        document.getElementById("grid-table-body").style.height = "calc(" + portfolioDivHeight + "px - 10.5rem)";

    },
  



    changeTradesVisible: function(index){
      this.portfolio[index].isTradeVisible = !this.portfolio[index].isTradeVisible;
    },


}
}




